(function () {
  var TRAVEL_MS = 420;
  var SCALE_DIP = 0.22;
  var DRAG_THRESHOLD = 6;
  var SCROLL_EDGE = 48;

  var section = document.querySelector('.htg-section--story');
  if (!section) return;

  var scrollport = section.querySelector('.htg-timeline-track-scroll');
  var track = section.querySelector('.htg-timeline-track');
  var thumb = section.querySelector('.htg-timeline-thumb');
  var face = section.querySelector('.htg-timeline-thumb-face');
  var progress = section.querySelector('.htg-timeline-progress');
  var stops = section.querySelectorAll('.htg-timeline-stop');
  var panels = section.querySelectorAll('.htg-timeline-panel');
  var photo = section.querySelector('.htg-timeline-photo');
  if (!track || !thumb || !face || !progress || !stops.length) return;

  var rail = { centers: [], last: 0 };
  var mode = { kind: 'rest', seated: 0 };
  var seated = -1;
  var raf = 0;
  var token = 0;
  var dragOriginX = 0;
  var dragMoved = false;
  var suppressClick = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function measureRail() {
    var centers = [];
    for (var i = 0; i < stops.length; i++) {
      centers.push(stops[i].offsetLeft + stops[i].offsetWidth / 2);
    }
    rail = { centers: centers, last: Math.max(centers.length - 1, 0) };
  }

  function xFromStation(station) {
    var i = Math.floor(station);
    if (i >= rail.last) return rail.centers[rail.last] || 0;
    if (i < 0) return rail.centers[0] || 0;
    return lerp(rail.centers[i], rail.centers[i + 1], station - i);
  }

  function stationFromX(x) {
    var centers = rail.centers;
    if (!centers.length) return 0;
    if (x <= centers[0]) return 0;
    if (x >= centers[rail.last]) return rail.last;
    for (var i = 0; i < rail.last; i++) {
      var a = centers[i];
      var b = centers[i + 1];
      if (x <= b) {
        if (b === a) return i;
        return i + (x - a) / (b - a);
      }
    }
    return rail.last;
  }

  function stationFromClientX(clientX) {
    var x = clientX - track.getBoundingClientRect().left;
    return clamp(stationFromX(x), 0, rail.last);
  }

  function nearestIndex(station) {
    return Math.round(clamp(station, 0, rail.last));
  }

  function travelP(m, now) {
    if (m.ms <= 0) return 1;
    return clamp((now - m.t0) / m.ms, 0, 1);
  }

  function currentStation(now) {
    if (mode.kind === 'rest') return mode.seated;
    if (mode.kind === 'drag') return mode.station;
    return lerp(mode.from, mode.to, easeInOut(travelP(mode, now)));
  }

  function viewFromMode(m, now) {
    var station;
    var scale = 1;
    if (m.kind === 'rest') {
      station = m.seated;
    } else if (m.kind === 'drag') {
      station = m.station;
    } else {
      var p = travelP(m, now);
      station = lerp(m.from, m.to, easeInOut(p));
      scale = m.ms <= 0 ? 1 : 1 - SCALE_DIP * Math.sin(Math.PI * p);
    }
    return {
      station: station,
      seated: seated,
      scale: scale,
      dragging: m.kind === 'drag'
    };
  }

  function paint(view) {
    var x = xFromStation(view.station);
    var half = thumb.offsetWidth / 2;
    thumb.style.transform = 'translate3d(' + (x - half) + 'px, 0, 0)';
    face.style.transform = 'scale(' + view.scale + ')';
    progress.style.width = x + 'px';
    section.classList.toggle('htg-timeline-dragging', view.dragging);
    section.classList.toggle('htg-timeline-travelling', mode.kind === 'travel');
  }

  function cancelRaf() {
    if (raf) {
      cancelAnimationFrame(raf);
      raf = 0;
    }
  }

  function centerStop(index) {
    var active = stops[index];
    if (!active || !scrollport) return;
    var stopCenter = active.offsetLeft + active.offsetWidth / 2;
    var target = stopCenter - scrollport.clientWidth / 2;
    var max = scrollport.scrollWidth - scrollport.clientWidth;
    if (target < 0) target = 0;
    if (target > max) target = max;
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (typeof scrollport.scrollTo === 'function') {
      scrollport.scrollTo({ left: target, behavior: behavior });
    } else {
      scrollport.scrollLeft = target;
    }
  }

  function commit(index) {
    if (seated === index) return;
    seated = index;
    for (var i = 0; i < stops.length; i++) {
      stops[i].classList.toggle('htg-timeline-active', i === index);
      stops[i].classList.toggle('htg-timeline-past', i < index);
      if (i === index) {
        stops[i].setAttribute('aria-current', 'true');
      } else {
        stops[i].removeAttribute('aria-current');
      }
    }
    for (var j = 0; j < panels.length; j++) {
      panels[j].classList.toggle('htg-timeline-panel-active', j === index);
    }
    var src = stops[index].getAttribute('data-photo');
    if (photo && src && photo.getAttribute('src') !== src) {
      photo.src = src;
      photo.alt = stops[index].getAttribute('data-photo-alt') || '';
      photo.classList.remove('htg-timeline-photo-in');
      void photo.offsetWidth;
      photo.classList.add('htg-timeline-photo-in');
    }
    centerStop(index);
  }

  function startTravel(from, to) {
    to = nearestIndex(to);
    cancelRaf();
    token += 1;
    if (Math.abs(from - to) < 0.001 && seated === to) {
      mode = { kind: 'rest', seated: to };
      paint(viewFromMode(mode, performance.now()));
      return;
    }
    commit(to);
    var now = performance.now();
    var ms = prefersReducedMotion() ? 0 : TRAVEL_MS;
    if (ms === 0) {
      mode = { kind: 'rest', seated: to };
      paint(viewFromMode(mode, now));
      return;
    }
    mode = { kind: 'travel', from: from, to: to, t0: now, ms: ms, token: token };
    paint(viewFromMode(mode, now));
    raf = requestAnimationFrame(tick);
  }

  function tick(now) {
    if (mode.kind !== 'travel' || mode.token !== token) {
      raf = 0;
      return;
    }
    paint(viewFromMode(mode, now));
    if (travelP(mode, now) >= 1) {
      mode = { kind: 'rest', seated: mode.to };
      paint(viewFromMode(mode, now));
      raf = 0;
      return;
    }
    raf = requestAnimationFrame(tick);
  }

  function activate(index) {
    index = nearestIndex(index);
    if (mode.kind === 'rest' && seated === index) return;
    if (mode.kind === 'travel' && mode.to === index) return;
    startTravel(currentStation(performance.now()), index);
  }

  function keepThumbInScrollport(clientX) {
    if (!scrollport) return;
    var rect = scrollport.getBoundingClientRect();
    var max = scrollport.scrollWidth - scrollport.clientWidth;
    if (max <= 0) return;
    if (clientX > rect.right - SCROLL_EDGE) {
      scrollport.scrollLeft = Math.min(max, scrollport.scrollLeft + 12);
    } else if (clientX < rect.left + SCROLL_EDGE) {
      scrollport.scrollLeft = Math.max(0, scrollport.scrollLeft - 12);
    }
  }

  function beginDrag(e) {
    if (e.button !== 0) return;
    if (mode.kind === 'drag') return;
    e.preventDefault();
    var now = performance.now();
    var station = currentStation(now);
    cancelRaf();
    token += 1;
    dragOriginX = e.clientX;
    dragMoved = false;
    var rect = thumb.getBoundingClientRect();
    thumb.setPointerCapture(e.pointerId);
    mode = {
      kind: 'drag',
      pointerId: e.pointerId,
      grabOffsetX: e.clientX - (rect.left + rect.width / 2),
      station: station
    };
    paint(viewFromMode(mode, now));
  }

  function moveDrag(e) {
    if (mode.kind !== 'drag' || e.pointerId !== mode.pointerId) return;
    if (Math.abs(e.clientX - dragOriginX) >= DRAG_THRESHOLD) dragMoved = true;
    mode.station = stationFromClientX(e.clientX - mode.grabOffsetX);
    keepThumbInScrollport(e.clientX);
    paint(viewFromMode(mode, performance.now()));
  }

  function endDrag(e) {
    if (mode.kind !== 'drag' || e.pointerId !== mode.pointerId) return;
    if (dragMoved) suppressClick = true;
    startTravel(mode.station, nearestIndex(mode.station));
  }

  function onActivateClick(index) {
    if (suppressClick) {
      suppressClick = false;
      return;
    }
    activate(index);
  }

  function onResize() {
    measureRail();
    paint(viewFromMode(mode, performance.now()));
  }

  thumb.addEventListener('pointerdown', beginDrag);
  thumb.addEventListener('pointermove', moveDrag);
  thumb.addEventListener('pointerup', endDrag);
  thumb.addEventListener('pointercancel', endDrag);
  thumb.addEventListener('lostpointercapture', endDrag);
  window.addEventListener('pointermove', moveDrag);
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  for (var s = 0; s < stops.length; s++) {
    (function (index) {
      stops[index].addEventListener('click', function () {
        onActivateClick(index);
      });
    })(s);
  }

  track.addEventListener('click', function (e) {
    if (suppressClick) {
      suppressClick = false;
      return;
    }
    if (e.target.closest('.htg-timeline-stop, .htg-timeline-thumb')) return;
    activate(nearestIndex(stationFromClientX(e.clientX)));
  });

  if (window.ResizeObserver) {
    new ResizeObserver(onResize).observe(track);
  } else {
    window.addEventListener('resize', onResize);
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(onResize);
  }

  for (var k = 0; k < stops.length; k++) {
    var preload = stops[k].getAttribute('data-photo');
    if (preload) new Image().src = preload;
  }

  measureRail();
  commit(0);
  mode = { kind: 'rest', seated: 0 };
  paint(viewFromMode(mode, performance.now()));
})();
